<ng-template [ngIf]="template" [ngTemplateOutlet]="template" [ngTemplateOutletContext]="templateContext"></ng-template>
<ng-content *ngIf="!template"></ng-content>
